import { TimeSeparator, TimeUpDown } from './components';
import { FlexBox } from '@ardoq/layout';

type TimeProps = {
  readonly hours: number;
  readonly minutes: number;
  readonly isPreviousHourDisabled: boolean;
  readonly isPreviousMinuteDisabled: boolean;
  readonly incrementHour: VoidFunction;
  readonly decrementHour: VoidFunction;
  readonly addFifteenMinutes: VoidFunction;
  readonly subtractFifteenMinutes: VoidFunction;
};

const Time = ({
  hours,
  minutes,
  isPreviousHourDisabled,
  isPreviousMinuteDisabled,
  incrementHour,
  decrementHour,
  addFifteenMinutes,
  subtractFifteenMinutes,
}: TimeProps) => {
  return (
    <FlexBox gap="medium" justify="center" align="center">
      <TimeUpDown
        value={String(hours).padStart(2, '0')}
        onUpClick={incrementHour}
        onDownClick={decrementHour}
        isDownDisabled={isPreviousHourDisabled}
      />
      <TimeSeparator />
      <TimeUpDown
        value={String(minutes).padStart(2, '0')}
        onUpClick={addFifteenMinutes}
        onDownClick={subtractFifteenMinutes}
        isDownDisabled={isPreviousMinuteDisabled}
      />
    </FlexBox>
  );
};

export { Time };
